import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function AudienceSection() {
  const isFor = ['Mujeres de 62 a 70 años que viven en Estados Unidos.', 'Mujeres que prefieren entender sus finanzas en su propio idioma, con claridad y respeto.', 'Mujeres casadas, divorciadas o viudas que quieren asegurar su independencia.', 'Aquellas que no quieren ser una carga económica para sus hijos en el futuro.'];
  const isNotFor = ['Personas que no tienen créditos de trabajo o historial de pareja en USA.', 'Hombres (el enfoque es exclusivo para las normas que protegen a la mujer).', "Personas que buscan 'trucos' ilegales; aquí solo enseñamos normas vigentes."];
  return <section className="py-20 bg-[#FDF8F0]" data-id="element-9">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-16" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]" data-id="element-12">
            ¿Es esta guía para usted?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-13">
          {/* Para quién ES */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-md border-t-8 border-[#22C55E]" data-id="element-14">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 flex items-center gap-3" data-id="element-15">
              <span className="bg-green-100 text-green-600 p-2 rounded-full" data-id="element-16">
                <Check className="w-6 h-6" data-id="element-17" />
              </span>
              Para quién SÍ es esto
            </h3>
            <ul className="space-y-5" data-id="element-18">
              {isFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-19">
                  <Check className="w-6 h-6 text-[#22C55E] shrink-0 mt-1" data-id="element-20" />
                  <span className="text-gray-700" data-id="element-21">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quién NO ES */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-md border-t-8 border-[#EF4444]" data-id="element-22">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 flex items-center gap-3" data-id="element-23">
              <span className="bg-red-100 text-red-600 p-2 rounded-full" data-id="element-24">
                <X className="w-6 h-6" data-id="element-25" />
              </span>
              Para quién NO es esto
            </h3>
            <ul className="space-y-5" data-id="element-26">
              {isNotFor.map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-27">
                  <X className="w-6 h-6 text-[#EF4444] shrink-0 mt-1" data-id="element-28" />
                  <span className="text-gray-700" data-id="element-29">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}